import { Box, Typography, styled, Grid, useMediaQuery } from "@mui/material";
import color from "../../components/utils/Colors";
import { useEffect, useState } from "react";
import { getDataFromTable } from "../../services/services";
import { useUser } from "../../services/Context/UserContext";

const ContactDetails = () => {
  const { user } = useUser();
  const [data, setData] = useState<any>(null);
  const isSmallScreen2 = useMediaQuery("(max-width:600px)");

  useEffect(() => {
    const fetchAddress = async () => {
      if (!user?.id) return;

      try {
        const addressRes = await getDataFromTable("address", {
          userId: user.id,
        });

        const d = addressRes?.data?.data ?? addressRes?.data ?? addressRes;

        const addressData = Array.isArray(d) ? d[0] : d;

        setData(addressData);
      } catch (err) {
        console.error("Error fetching address:", err);
      }
    };

    fetchAddress();
  }, [user?.id]);

  const CustomTypo = styled(Typography)({
    color: color.textColor,
    fontSize: isSmallScreen2 ? "14px" : "20px",
    fontWeight: "bold",
    marginTop: "10px",
    height: "100%",
    display: "flex",
    alignItems: "center",
    width: isSmallScreen2 ? "40%" : "25%",
  });

  const CustomTypo1 = styled(Typography)({
    color: color.textColor,
    fontSize: isSmallScreen2 ? "14px" : "20px",
    width: isSmallScreen2 ? "60%" : "75%",
    marginTop: "10px",
    height: "100%",
    display: "flex",
    alignItems: "center",
    overflow: "auto",
    whiteSpace: "nowrap",
    "&::-webkit-scrollbar": {
      width: "6px",
      height: "4px",
    },
    "&::-webkit-scrollbar-track": {
      background: color.secondColor,
      borderRadius: "10px",
    },
    "&::-webkit-scrollbar-thumb": {
      background: color.firstColor,
      border: "solid 1px white",
      borderRadius: "10px",
    },
  });

  return (
    <Box
      sx={(theme) => ({
        marginTop: "25px",
        flex: 1,
        p: "3%",
        borderRadius: "16px",
        boxShadow: 2,
        bgcolor:
          theme.palette.mode === "light" ? "#faecfa71" : "rgba(0, 0, 0, 0.4)",
        backdropFilter: "blur(2px)",
      })}
    >
      <Grid
        container
        spacing={2}
        sx={{ py: 1, pl: isSmallScreen2 ? 1 : 4, pb: 2 }}
      >
        <Grid item xs={12}>
          {[
            ["Address Type :", data?.addressType],
            ["Address :", data?.address],
            ["City :", data?.city],
            ["Country :", data?.country],
            ["Postal Code :", data?.postalCode],
          ].map(([label, value], index) => (
            <Box
              key={index}
              sx={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <CustomTypo>{label}</CustomTypo>
              <CustomTypo1>{value ?? "—"}</CustomTypo1>
            </Box>
          ))}
        </Grid>
      </Grid>
    </Box>
  );
};

export default ContactDetails;
